
$(document).on("franchise_documents#index:loaded", function() {
  $("#document_search input").keyup(function() 
    {
    $.get($("#document_search").attr("action"), $("#document_search").serialize(),  null, "script");
    return false;
  });

});

  


